import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { hasChanged } from 'src/app/utils/functions/change-helpers';
import { ScriptParams } from 'src/app/utils/functions/load-external-script';

import { ScriptLoadingService } from './script-loading.service';

@Component({
  selector: 'cc-script-loader',
  templateUrl: './script-loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScriptLoaderComponent implements OnChanges {
  @Input() public scriptParams!: ScriptParams;
  /**
   * If (optional) promise set it is checked whether script loading is really needed or can be skipped (e.g. when script already got loaded)
   * Will skip script loading and show content immediately on resolve, will load script (and show content later once script is loaded) on reject.
   */
  @Input() public preScriptLoad?: Promise<void>;
  @Input() public showNotificatonOnError = false;
  @Input() public errorNotificationI18nKey?: string;

  public showContent = false;

  public constructor(
    private readonly scriptLoadingService: ScriptLoadingService,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  public ngOnChanges({ scriptParams, preScriptLoad }: SimpleChanges): void {
    if (hasChanged(scriptParams)) {
      const preScriptLoadPromise = preScriptLoad?.currentValue;

      preScriptLoadPromise
        ? preScriptLoadPromise.then(() => this.enableContent()).catch(() => this.loadScript(scriptParams.currentValue))
        : this.loadScript(scriptParams.currentValue);
    }
  }

  private loadScript(scriptParams: ScriptParams): void {
    (async () => {
      try {
        await this.scriptLoadingService.load(scriptParams);
        this.enableContent();
      } catch (err) {
        if (this.showNotificatonOnError && this.errorNotificationI18nKey) {
          this.scriptLoadingService.raiseErrorNotification(this.errorNotificationI18nKey);
        }
      }
    })();
  }

  private enableContent(): void {
    this.showContent = true;
    this.changeDetectorRef.markForCheck();
  }
}
